<template>
<div class="issue-container" style="background-image:url('https://assets.realclear.com/images/48/482021_6_.jpg');background-size:cover;">
    <div class="issue">
        <h1>Equality</h1>
    </div>
</div><!-- issue-container -->
</template>

<script>
export default {
    name: 'pa-heading-image',
}
</script>

<style lang="scss">

</style>